import {
  SETTINGS_PAYMENT_HISTORY,
  LOAD_PROFILE_DETAILS,
  UPDATE_PROFILE_DETAILS,
  UPDATE_PASSWORD,
  CLEAR_PASSWORD,
  RECURRING_PAYMENT,
  USER_PAST_UPLOADS,
} from "../../common/constants";

export const loadPastUploads = function (email, page, limit){
  return {type:USER_PAST_UPLOADS, email, page, limit}
}

export const loadPaymentHistory = function (mmCustomerID) {
  return { type: SETTINGS_PAYMENT_HISTORY, mmCustomerID: mmCustomerID };
};

export const loadProfileDetails = function (username) {
  return { type: LOAD_PROFILE_DETAILS, username: username };
};

export const updateProfileDetails = (profileInfo) => {
  return { type: UPDATE_PROFILE_DETAILS, profileInfo: profileInfo };
};

export const updatePasswordDetails = (passwordInfo) => {
  return { type: UPDATE_PASSWORD, passwordInfo: passwordInfo };
};

export const clearPasswordDetails = (passwordInfo) => {
  return { type: CLEAR_PASSWORD, passwordInfo: passwordInfo };
};

export const loadRecurringPayment = function () {
  // console.log("loadRecurringPayment start");
  return { type: RECURRING_PAYMENT };
};



// WEBPACK FOOTER //
// ./src/Containers/Settings/actions.js